module.exports = __webpack_public_path__ + "static/007264-aa70ff1892efe281ff8e4defa092f364.jpg";